import {Injectable} from '@angular/core';

@Injectable()
export class ObjectCheckInConfig {
  templateApiUrl: string;
  objectCheckInUrl: string;
  masterDataOrigin: string;
}
